import TopNavBar from "../../components/reusables/topNavBar";
import Dashboard from "./components/dashboard";

function Financial() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar
                title={"Financeiro"}
                subtitle={"Gerenciamento financeiro e métricas de negócio."}
            />
            <div className='mx-4 sm:mx-10 my-6 flex-1 font-poppins text-custom_lighter_gray_font'>
                <Dashboard />
            </div>
        </div>
    )
}

export default Financial